module.exports = __webpack_public_path__ + "images/bannerEN-8487d2e8b2ec1b439be5cd240493fd38.png";